import { ref } from 'vue'

export const keyboardIsVisible = ref<boolean>(false)
export const keyboardHeight = ref<number>()
